import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { AnchorSectionKey } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/hooks/anchor';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { TransactionsDetailLayoutSwitch } from './LayoutSwitch';

type TransactionsDetailSectionProps = {
  reportId: string;
};

export const TransactionsDetailSection: FC<TransactionsDetailSectionProps> =
  memo(({ reportId }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading
        id={AnchorSectionKey.TRANSACTIONS_DETAIL}
        title={t('approving_invoice_reports.transactions.title')}
      >
        <TransactionsDetailLayoutSwitch reportId={reportId} />
      </SectionHeading>
    );
  });
TransactionsDetailSection.displayName = 'TransactionsDetailSection';
